import { render, staticRenderFns } from "./normalQuestion.vue?vue&type=template&id=10e9401a&scoped=true&"
import script from "./normalQuestion.vue?vue&type=script&lang=js&"
export * from "./normalQuestion.vue?vue&type=script&lang=js&"
import style0 from "./normalQuestion.vue?vue&type=style&index=0&id=10e9401a&prod&lang=scss&"
import style1 from "./normalQuestion.vue?vue&type=style&index=1&id=10e9401a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e9401a",
  null
  
)

export default component.exports